export interface TrainingLaunch {
  id: string;
  userId: string;
  timestamp: number;
  note?: string;
  rpmMax: number;
  rpmAvg: number;
  rpmHistory: number[];
  lastAngleX: number;
  lastAngleY: number;
  energy: number;
  pulses: number;
  estSpinTime: number;
  consistency: number;
  launchDuration: number;
  launchScore: number;
  speedKmh: number;
  createdAt: Date;
}

export interface RpmLeaderboardEntry {
  userId: string;
  displayName: string;
  avatarUrl?: string;
  bestRpm: number;
  totalLaunches: number;
  avgConsistency: number;
  avgScore: number;
}

export interface UserTrainingStats {
  totalLaunches: number;
  bestRpm: number;
  avgRpm: number;
  avgConsistency: number;
  avgScore: number;
  bestSpeedKmh: number;
  lastLaunchAt: number | null;
}
